import * as React from 'react'

function YouTubeIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 25" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            stroke="#627680"
            strokeWidth="1"
            d="M0 0H28V25H0z"
            data-name="youtube default"
            transform="translate(356 3599)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 539" transform="translate(-356 -3599)">
        <g data-name="youtube default" transform="translate(356 3598.916)">
          <path
            fill="#627680"
            d="M12.855 1.806c-5.557 0-8.86.719-10.394 2.263a5.379 5.379 0 00-1.354 2.949 29.488 29.488 0 00-.287 5.3 33.552 33.552 0 00.311 5.248A6.335 6.335 0 002.4 20.692c.939 1.11 3.044 2.586 10.454 2.586 7.512 0 9.707-1.469 10.7-2.574C25 19.112 25.28 16.533 25.3 12.33c-.035-3.98-.323-6.428-1.74-7.967-1.606-1.745-5.008-2.557-10.705-2.557m0-1.806c13.159 0 14.181 4.265 14.251 12.327-.038 8.559-1.1 12.758-14.251 12.758S-.929 20.735-.987 12.327-.3 0 12.855 0z"
            data-name="Path 67834 - Outline"
            transform="translate(.99)"
          ></path>
          <path fill="#fff" d="M4.5 0L9 8H0z" data-name="Polygon 26" transform="rotate(90 5.458 13.542)"></path>
          <path
            fill="#627680"
            d="M5.8 0l5.8 10.152H0zm2.56 8.271L5.8 3.792 3.242 8.271z"
            data-name="Polygon 26 - Outline"
            transform="rotate(90 6.983 13.725)"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default YouTubeIcon
